// ##### Komarov 2025-07-22
import React from 'react';
// ##### 25-05-21 Komarov
import SmallScreenTopHotelsDiv from './SmallScreenTopHotelsDiv';

// ##### Komarov 2025-07-22
const SmallScreenTopHotels = ({ TopHotelContents, GetHotelDetails }) => {
  return (
    <SmallScreenTopHotelsDiv width="100vw" className="lessThanOrEqual_425" TopHotelContents={TopHotelContents} GetHotelDetails={GetHotelDetails} />
  );
}; // ##### 23-10-10 Komarov

export default SmallScreenTopHotels;
